import { render, staticRenderFns } from "./DialogDefault.vue?vue&type=template&id=46bd690a&scoped=true"
import script from "./DialogDefault.vue?vue&type=script&lang=js"
export * from "./DialogDefault.vue?vue&type=script&lang=js"
import style0 from "./DialogDefault.vue?vue&type=style&index=0&id=46bd690a&prod&lang=css"
import style1 from "./DialogDefault.vue?vue&type=style&index=1&id=46bd690a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bd690a",
  null
  
)

export default component.exports